import { useMemo } from "react";
import styled from "styled-components";
import { tags } from "@sablier/v2-constants";
import { useT } from "@sablier/v2-locales";
import { _ } from "@sablier/v2-mixins";
import { Ensurance, Warning } from "~/client/components/molecules";
import {
  usePollingAwareness,
  useStreamCurrent,
  useWarning,
} from "~/client/hooks";
import Confirmation from "../Confirmation";
import Summary from "../Summary";

const WrapperPartial = styled.div`
  ${(props) => props.theme.styles.column}
  & {
    row-gap: calc(${(props) => props.theme.sizes.edge} * 3 / 2);
    width: 100%;
    padding: calc(${(props) => props.theme.sizes.edge} * 3 / 2);
    padding-right: calc(${(props) => props.theme.sizes.edge} * 2);
    padding-left: calc(${(props) => props.theme.sizes.edge} * 2);
  }
`;

const Divider = styled.div`
  width: 100%;
  height: 2px;
  background-color: ${(props) => props.theme.colors.border};
`;

const Wrapper = styled(WrapperPartial)`
  ${(props) => props.theme.medias.maxMD} {
    padding-right: calc(${(props) => props.theme.sizes.edge} * 3 / 2);
    padding-left: calc(${(props) => props.theme.sizes.edge} * 3 / 2);
  }
  ${(props) => props.theme.medias.maxSM} {
    row-gap: calc(${(props) => props.theme.sizes.edge} * 3 / 4);
    padding: calc(${(props) => props.theme.sizes.edge} * 3 / 4);
    padding-right: calc(${(props) => props.theme.sizes.edge} * 3 / 4);
    padding-left: calc(${(props) => props.theme.sizes.edge} * 3 / 4);
  }
`;

function Body() {
  usePollingAwareness({ condition: true, page: "profile" });
  const { t } = useT();

  const { stream } = useStreamCurrent();
  const { state } = useWarning("renounce", stream);
  const hasEnded = useMemo(() => state === "ended", [state]);

  return (
    <Wrapper data-cy={tags.coverRenounce}>
      <Warning.Bundle purpose={"renounce"} stream={stream} />

      <Ensurance
        isHidden={hasEnded}
        value={t("modalCovers.renounce.ensurance")}
      />
      <Summary isStale={hasEnded} />
      <Divider />
      <Confirmation />
    </Wrapper>
  );
}

export default Body;
